 <template>
  <el-dialog
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="visible"
  >
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item label="昵称: " prop="name" :label-width="formLabelWidth">
          <el-input
            v-model="form.name"
            autocomplete="off"
            :maxlength="maxlength"
            placeholder="请输入昵称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱: " prop="email" :label-width="formLabelWidth">
          <el-input
            v-model="form.email"
            autocomplete="off"
            placeholder="请输入邮箱"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-button">
        <el-button type="primary" @click="handelConfirm('form', 0)">
          启 用
        </el-button>

        <el-button
          class="confirm-button"
          v-if="this.dialogTitle == '编辑邮箱' && this.updateId"
          @click="handelConfirm('form', 1)"
        >
          保 存
        </el-button>

        <el-button class="confirm-button" v-else @click="resetForm('form')"
          >重 置</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import emailApi from '@/api/email'
import { mapRequestActions } from '@/utils'
export default {
  data () {
    return {
      dialogTitle: '新建邮箱',
      loading: false,
      updateId: '',
      visible: false,
      formLabelWidth: '120px',
      maxlength: 200,
      form: {
        name: '',
        email: ''
      },
      rule: {
        name: [
          {
            required: true,
            message: '请输入昵称',
            trigger: 'change'
          }
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'change'
          },
          {
            pattern: '^([a-z0-9A-Z]+[-_|\\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-zA-Z]{2,}$',
            // pattern: /^\w+@(?:\d+|[a-zA-Z]+)\.[a-zA-Z]+/,
            message: '请输入正确的邮箱'
          }
        ]
      }
    }
  },
  methods: {
    ...mapRequestActions(emailApi),
    handelConfirm (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newArr = Object.assign(this.form, {
            status: type,
            id: this.updateId
          })
          // 编辑状态 且 点击发布
          if (this.dialogTitle === '编辑邮箱' && type === 0) {
            this.updateEmailAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('编辑成功！')
                this.isShow(false)
                this.$parent.handleEmailList()
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            })
          } else if (this.dialogTitle === '编辑邮箱' && type === 1) {
            // 编辑状态 且 点击保存
            this.updateEmailAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('保存成功！')
                this.isShow(false)
                this.$parent.handleEmailList()
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            })
          } else {
            this.addEmailAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('新增成功！')
                this.isShow(false)
                this.$parent.handleEmailList()
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            })
          }
        } else {
          // todo
        }
      })
    },
    showAddDialog () {
      setTimeout(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      }, 0)
      Object.assign(this.$data, this.$options.data())
      this.dialogTitle = '新建邮箱'
      this.isShow(true)
    },
    async showEditDialog (id) {
      this.updateId = id
      this.dialogTitle = '编辑邮箱'
      this.isShow(true)
      const data = await this.queryDetailByIdAction({ id })
      if (data.status) {
        this.form.name = data.result.name
        this.form.email = data.result.email
      }
    },
    isShow (isVisible) {
      this.visible = isVisible
    },

    /**
     * 新建页面 -- 重置按钮
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang='less' scoped>
.el-form {
  padding: 0 30px 0 15px;
}
.dialog-button {
  text-align: center;
  .confirm-button {
    margin-left: 50px;
    margin-top: 50px;
  }
}
</style>
